import { observer } from "mobx-react-lite";
import React, {} from "react";
import { Link } from "react-router-dom";
import { List, Image, Popup } from "semantic-ui-react";
import { UserActivity } from "../../../app/models/userActivity";
import ProfileCard from "../../profiles/ProfileCard";

interface Props {
    profileAttendees: UserActivity[];
}

function ActivityListItemAttendee(props: Props) {
    const styles = {
        borderColor: 'orange',
        borderWidth: 3,
    }
    
    return (
        <List horizontal>
            {/* <List.Item >
                <Image size='mini' circular src={'/assets/user.png'} />
            </List.Item> */}
            
            {props.profileAttendees.map(profileAttendee => (
                // <List.Item key={profileAttendee.userName} as={Link} to={`/profiles/${profileAttendee.userName}`} >
                //     <Image size='mini' circular src={profileAttendee.image || '/assets/user.png'} />
                // </List.Item>

                <Popup hoverable key={profileAttendee.userName} trigger={
                    <List.Item key={profileAttendee.userName} as={Link} to={`/profiles/${profileAttendee.userName}`} >
                        <Image 
                            size='mini' 
                            circular 
                            bordered
                            style={profileAttendee.bFollowing ? styles : null }
                            src={profileAttendee.photoUrl || '/assets/user.png'} 
                        />
                    </List.Item>
                }>
                    <Popup.Content>
                        <ProfileCard profile={profileAttendee} />
                    </Popup.Content>
                </Popup>
            ))}

        </List>
    )
}

export default observer(ActivityListItemAttendee);